import styled, { keyframes } from "styled-components";
import {
  REGISTRATION_FONT_BODY,
  REGISTRATION_FONT_DISPLAY,
} from "../../../RegistrationLayout/registrationTheme";

const popIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(8, 15, 28, 0.5);
`;

export const ModalPanel = styled.div`
  background: #ffffff;
  border-radius: 16px;
  max-width: 480px;
  width: 100%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(8, 15, 28, 0.2);
  animation: ${popIn} 0.2s ease;
  font-family: ${REGISTRATION_FONT_BODY};
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px 16px;
  border-bottom: 1px solid rgba(30, 42, 53, 0.08);
  position: sticky;
  top: 0;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  z-index: 1;
`;

export const ModalTitle = styled.h3`
  font-family: ${REGISTRATION_FONT_DISPLAY};
  font-size: 20px;
  font-weight: 500;
  color: #2d3f52;
  margin: 0;
`;

export const ModalCloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6e7d8f;
  line-height: 1;
  padding: 4px;
  font-family: ${REGISTRATION_FONT_BODY};
`;

export const ModalBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const PolicyScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-right: -8px;
  padding-right: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(110, 125, 143, 0.45) transparent;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(110, 125, 143, 0.35);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(110, 125, 143, 0.55);
  }
`;

export const PolicyLoadingText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #6e7d8f;
  line-height: 1.65;
  font-family: ${REGISTRATION_FONT_BODY};
`;

export const PolicyErrorText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #c4614a;
  line-height: 1.65;
  font-family: ${REGISTRATION_FONT_BODY};
`;

export const PolicyHtmlContent = styled.div`
  font-family: ${REGISTRATION_FONT_BODY};
  color: #6e7d8f;
  font-size: 13px;
  line-height: 1.65;

  .policy-notice-box {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: rgba(174, 206, 56, 0.08);
    border: 1px solid rgba(174, 206, 56, 0.3);
    border-radius: 10px;
    padding: 14px 16px;
    margin: 0 0 22px;
  }

  .policy-notice-icon {
    flex-shrink: 0;
    font-size: 16px;
    line-height: 1.65;
    margin-top: 1px;
  }

  .policy-notice-text {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: #8aab15;
    line-height: 1.65;
    font-family: ${REGISTRATION_FONT_BODY};

    &,
    strong,
    span,
    a {
      color: #8aab15;
      font-weight: 600;
    }
  }

  h4 {
    font-size: 13px;
    font-weight: 700;
    color: #2d3f52;
    margin: 0 0 6px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  ol {
    margin: 0;
    padding: 0;
    list-style: none;
    counter-reset: policy-section;
  }

  ol > li {
    position: relative;
    padding: 0 0 16px 28px;
    margin: 0 0 16px;
    border-bottom: 1px solid rgba(30, 42, 53, 0.08);
    counter-increment: policy-section;

    &::before {
      content: counter(policy-section);
      position: absolute;
      left: 0;
      top: 1px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #8aab15;
      color: #ffffff;
      font-size: 11px;
      font-weight: 700;
      line-height: 20px;
      text-align: center;
    }

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  ol > li > strong:first-child {
    display: inline;
    font-size: 13px;
    font-weight: 700;
    color: #2d3f52;
    margin-bottom: 0;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  ol > li > p {
    margin-top: 6px;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #6e7d8f;
    line-height: 1.65;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  ol + p,
  .policy-footer-text {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(30, 42, 53, 0.08);
  }

  p:not(:first-child):not(:has(+ ol)):not(.policy-footer-text) {
    margin-top: 6px;
  }

  strong {
    color: #5a6b80;
    font-weight: 600;
  }

  a {
    color: #8aab15;
    font-weight: 600;
    text-decoration: underline;
    font-family: ${REGISTRATION_FONT_BODY};
  }
`;

export const GotItBtn = styled.button`
  margin-top: 20px;
  width: 100%;
  padding: 13px;
  border-radius: 999px;
  background: #2d3f52;
  color: #ffffff;
  border: none;
  font-family: ${REGISTRATION_FONT_BODY};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #5a6b80;
  }
`;
